import React from 'react'
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import './bootstrap.min.css';
import Site from './components/Site';
import Home from './components/Home';


function App() {

  window.onunload = () => {
    // Clear the local storage when closing the tab
    window.localStorage.clear()
  }
  return (


    <Router>

      <Routes>
        <Route path="backToPast/" element={<Site />} />
        <Route exact path="/" element={<Home />} />
      </Routes>

    </Router>

  );
}

export default App;
